import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import TemplateSectionEditForm from "./form/edit.component.jsx"
import SideBar from '../../common/layout/sidebar.component.jsx'
import {Redirect} from "react-router-dom";

class TemplateSectionNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            redirect: ''
        }
        this.redirect = this.redirect.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
    }

    redirect() {
        this.setState({ redirect: <Redirect to={{ pathname: '/templates/' + this.props.match.params.documentId + '/sections/preview'}}/> })
    }

    render() {
        return (
            <div>
                {this.state.redirect}
                <TemplateSectionEditForm documentId={this.props.match.params.documentId} onChange={this.redirect} onClose={this.redirect} />
            </div>
        );
    }
}

export default TemplateSectionNew


// WEBPACK FOOTER //
// ./src/template/sections/new.component.jsx